import { AttendanceSummary } from "./attendance-summary";

export class AttendanceCalendarModel {
    date: Date;
    attendance_summary: AttendanceSummary;
}